'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import useSWR from 'swr';
import RecommendCreators from '@/app/[locale]/(worlds)/profile/components/RecommendCreators';
import UserFollowingPublicRooms from '@/app/[locale]/(worlds)/profile/components/UserFollowingPublicRooms';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useUAContext } from '@/context/UAContext';
import { AuthenticatedCommunityIdentity, AuthenticatedFollowingWithRooms, getAuthenticatedFollowingsWithRooms } from '@/services/community';
const FOLLOWINGS_FETCH_SIZE = 4;
function UserFollowing() {
  const $ = _c(21);
  const t = useTranslations();
  const {
    store
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  const preferredUsername = store?.profile?.userId;
  const {
    totalVramKb
  } = useUAContext();
  let t0;
  if ($[0] !== htcToken || $[1] !== preferredUsername) {
    t0 = htcToken && preferredUsername ? {
      htcToken,
      preferredUsername
    } : undefined;
    $[0] = htcToken;
    $[1] = preferredUsername;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const identity = t0;
  let t1;
  if ($[3] !== identity || $[4] !== totalVramKb) {
    t1 = () => getAuthenticatedFollowingsWithRooms(identity, totalVramKb, 0, FOLLOWINGS_FETCH_SIZE, 3);
    $[3] = identity;
    $[4] = totalVramKb;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    data: followingsData
  } = useSWR(identity && totalVramKb != null ? "followingsWithRooms" : null, t1);
  let t2;
  if ($[6] !== followingsData?.data) {
    t2 = followingsData?.data || [];
    $[6] = followingsData?.data;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const followings = t2 as AuthenticatedFollowingWithRooms[];
  let t3;
  if ($[8] !== followings) {
    t3 = Array.isArray(followings) ? followings.filter(_temp) : [];
    $[8] = followings;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const followingsWithRooms = t3;
  let t4;
  if ($[10] !== t) {
    t4 = t("profile-page.latest-updates-section-title");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <h2 className="subheader-1 md:header-4 relative mb-4 font-bold md:mb-6">{t4}</h2>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== followingsData || $[15] !== followingsWithRooms.length || $[16] !== identity) {
    t6 = followingsWithRooms.length > 0 ? <UserFollowingPublicRooms followingsData={followingsData} identity={identity} /> : <RecommendCreators />;
    $[14] = followingsData;
    $[15] = followingsWithRooms.length;
    $[16] = identity;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div id="following" className="flex scroll-mt-40 flex-col px-4 md:px-8 lg:px-18">{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp(t0) {
  const {
    publicRooms
  } = t0;
  return publicRooms && publicRooms.length > 0;
}
export default UserFollowing;